<template>
  <div class="cont-box">
    <img src="../../assets/c-bg-top.png">
    <img src="../../assets/c-bg-bottom.png" class="img01">
    <div class="cont">
      <div class="header">
        <img class="logo" src="../../assets/c-logo.png">
        <p class="title-d">客户满意度调查表</p>
        <p class="title-c">尊敬的客户:<br><span class="title-span">
            感谢您长期以来对科大智能的信任与支持！科大智能一直秉承“智能科技，智慧未来”的愿景，以技术创新为动力、客户需求为导向，为客户提供优质的产品和服务。为便于我们持续改进，提高产品和服务质量，敬请您扫描二维码如实填写本调查问卷。科大智能对您的支持深表感谢！</span>
        </p>
      </div>
      <el-form label-position="top" label-width="80px" :rules="rules" ref="subData" :model="subData">
        <el-form-item label="基本信息:" prop="company">
          <el-input v-model="subData.company" placeholder="客户名称" clearable></el-input>
        </el-form-item>
        <el-form-item prop="provinceCityArea">
          <el-cascader placeholder="区域（省/市/县）" :options="options" v-model="subData.provinceCityArea"
            @change="handleChange" clearable popper-class="my-pop"></el-cascader>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model="subData.name" placeholder="客户姓名(非必填)" clearable></el-input>
        </el-form-item>
        <el-form-item prop="tel">
          <el-input v-model="subData.tel" placeholder="联系方式(非必填)" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品类别:" prop="type">
          <el-checkbox-group v-model="subData.type">
            <el-checkbox :label="1" name="type">DTU</el-checkbox>
            <el-checkbox :label="2" name="type">FTU</el-checkbox>
            <el-checkbox :label="3" name="type">故障指示器</el-checkbox>
            <el-checkbox :label="4" name="type">用电集采</el-checkbox>
            <el-checkbox :label="5" name="type">环网柜</el-checkbox>
            <el-checkbox :label="6" name="type">断路器</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="1、产品外观设计是否满意？包装防护是否有效？" prop="q1.grade">
          <el-radio-group v-model="subData.q1.grade">
            <el-radio :label="5">非常满意</el-radio>
            <el-radio :label="4">满意</el-radio>
            <el-radio :label="3">基本满意</el-radio>
            <el-radio :label="2">不满意</el-radio>
            <el-radio :label="1">非常不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="subData.q1.grade !== '' && subData.q1.grade < 3">
          <el-form-item prop="q1.remark">
            <el-input type="textarea" v-model="subData.q1.remark" :rows="4"
              placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="2、产品功能、性能是否满足您的使用需求？">
        </el-form-item>
        <template v-if="subData.type.indexOf(1)+1">
          <el-form-item label="DTU产品:" prop="p1.num">
          </el-form-item>
          <el-form-item label="① 设备在线稳定性:" prop="p1.q1.grade">
            <el-radio-group v-model="subData.p1.q1.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p1.q1.grade !== '' && subData.p1.q1.grade < 3">
            <el-form-item prop="p1.q1.remark">
              <el-input type="textarea" v-model="subData.p1.q1.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="② 遥信、遥测上报准确性，遥控动作准确性:" prop="p1.q2.grade">
            <el-radio-group v-model="subData.p1.q2.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p1.q2.grade !== '' && subData.p1.q2.grade < 3">
            <el-form-item prop="p1.q2.remark">
              <el-input type="textarea" v-model="subData.p1.q2.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="③ 保护功能的准确性:" prop="p1.q3.grade">
            <el-radio-group v-model="subData.p1.q3.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p1.q3.grade !== '' && subData.p1.q3.grade < 3">
            <el-form-item prop="p1.q3.remark">
              <el-input type="textarea" v-model="subData.p1.q3.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="④ 调试软件和就地维护功能的便捷性:" prop="p1.q4.grade">
            <el-radio-group v-model="subData.p1.q4.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p1.q4.grade !== '' && subData.p1.q4.grade < 3">
            <el-form-item prop="p1.q4.remark">
              <el-input type="textarea" v-model="subData.p1.q4.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑤ 产品功能的可扩展:" prop="p1.q5.grade">
            <el-radio-group v-model="subData.p1.q5.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p1.q5.grade !== '' && subData.p1.q5.grade < 3">
            <el-form-item prop="p1.q5.remark">
              <el-input type="textarea" v-model="subData.p1.q5.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑥其余功能/性能:" prop="p1.other">
            <el-radio-group v-model="subData.p1.other">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">其它</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p1.other === 1">
            <el-form-item label="" prop="p1.otherCont">
              <el-input v-model="subData.p1.otherCont" placeholder="请填写"></el-input>
            </el-form-item>
            <el-form-item label="" prop="p1.otherGrade">
              <el-radio-group v-model="subData.p1.otherGrade">
                <el-radio :label="5">非常满意</el-radio>
                <el-radio :label="4">满意</el-radio>
                <el-radio :label="3">基本满意</el-radio>
                <el-radio :label="2">不满意</el-radio>
                <el-radio :label="1">非常不满意</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="subData.p1.otherGrade !== '' && subData.p1.otherGrade < 3">
            <el-form-item prop="p1.otherRemark">
              <el-input type="textarea" v-model="subData.p1.otherRemark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
        </template>
        <template v-if="subData.type.indexOf(2)+1">
          <el-form-item label="FTU产品:" prop="p2.num">
          </el-form-item>
          <el-form-item label="① 设备在线稳定性:" prop="p2.q1.grade">
            <el-radio-group v-model="subData.p2.q1.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p2.q1.grade !== '' && subData.p2.q1.grade < 3">
            <el-form-item prop="p2.q1.remark">
              <el-input type="textarea" v-model="subData.p2.q1.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="② 遥信、遥测上报准确性，遥控动作准确性:" prop="p2.q2.grade">
            <el-radio-group v-model="subData.p2.q2.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p2.q2.grade !== '' && subData.p2.q2.grade < 3">
            <el-form-item prop="p2.q2.remark">
              <el-input type="textarea" v-model="subData.p2.q2.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="③ 保护功能的准确性:" prop="p2.q3.grade">
            <el-radio-group v-model="subData.p2.q3.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p2.q3.grade !== '' && subData.p2.q3.grade < 3">
            <el-form-item prop="p2.q3.remark">
              <el-input type="textarea" v-model="subData.p2.q3.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="④ 短路隔离或指示功能准确性:" prop="p2.q4.grade">
            <el-radio-group v-model="subData.p2.q4.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p2.q4.grade !== '' && subData.p2.q4.grade < 3">
            <el-form-item prop="p2.q4.remark">
              <el-input type="textarea" v-model="subData.p2.q4.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑤ 调试软件和就地维护功能的便捷性:" prop="p2.q5.grade">
            <el-radio-group v-model="subData.p2.q5.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p2.q5.grade !== '' && subData.p2.q5.grade < 3">
            <el-form-item prop="p2.q5.remark">
              <el-input type="textarea" v-model="subData.p2.q5.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑥ 其余功能/性能:" prop="p2.other">
            <el-radio-group v-model="subData.p2.other">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">其它</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p2.other === 1">
            <el-form-item label="" prop="p2.otherCont">
              <el-input v-model="subData.p2.otherCont" placeholder="请填写"></el-input>
            </el-form-item>
            <el-form-item label="" prop="p2.otherGrade">
              <el-radio-group v-model="subData.p2.otherGrade">
                <el-radio :label="5">非常满意</el-radio>
                <el-radio :label="4">满意</el-radio>
                <el-radio :label="3">基本满意</el-radio>
                <el-radio :label="2">不满意</el-radio>
                <el-radio :label="1">非常不满意</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="subData.p2.otherGrade !== '' && subData.p2.otherGrade < 3">
            <el-form-item prop="p2.otherRemark">
              <el-input type="textarea" v-model="subData.p2.otherRemark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
        </template>
        <template v-if="subData.type.indexOf(3)+1">
          <el-form-item label="故指产品:" prop="p3.num">
          </el-form-item>
          <el-form-item label="① 设备在线稳定性:" prop="p3.q1.grade">
            <el-radio-group v-model="subData.p3.q1.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p3.q1.grade !== '' && subData.p3.q1.grade < 3">
            <el-form-item prop="p3.q1.remark">
              <el-input type="textarea" v-model="subData.p3.q1.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="② 短路故障准确性:" prop="p3.q2.grade">
            <el-radio-group v-model="subData.p3.q2.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p3.q2.grade !== '' && subData.p3.q2.grade < 3">
            <el-form-item prop="p3.q2.remark">
              <el-input type="textarea" v-model="subData.p3.q2.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="③ 接地故障准确性:" prop="p3.q3.grade">
            <el-radio-group v-model="subData.p3.q3.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p3.q3.grade !== '' && subData.p3.q3.grade < 3">
            <el-form-item prop="p3.q3.remark">
              <el-input type="textarea" v-model="subData.p3.q3.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="④ 安装、维护便捷性:" prop="p3.q4.grade">
            <el-radio-group v-model="subData.p3.q4.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p3.q4.grade !== '' && subData.p3.q4.grade < 3">
            <el-form-item prop="p3.q4.remark">
              <el-input type="textarea" v-model="subData.p3.q4.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑤ 其余功能/性能:" prop="p3.other">
            <el-radio-group v-model="subData.p3.other">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">其它</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p3.other === 1">
            <el-form-item label="" prop="p3.otherCont">
              <el-input v-model="subData.p3.otherCont" placeholder="请填写"></el-input>
            </el-form-item>
            <el-form-item label="" prop="p3.otherGrade">
              <el-radio-group v-model="subData.p3.otherGrade">
                <el-radio :label="5">非常满意</el-radio>
                <el-radio :label="4">满意</el-radio>
                <el-radio :label="3">基本满意</el-radio>
                <el-radio :label="2">不满意</el-radio>
                <el-radio :label="1">非常不满意</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="subData.p3.otherGrade !== '' && subData.p3.otherGrade < 3">
            <el-form-item prop="p3.otherRemark">
              <el-input type="textarea" v-model="subData.p3.otherRemark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
        </template>
        <template v-if="subData.type.indexOf(4)+1">
          <el-form-item label="用电集采产品:" prop="p4.num">
          </el-form-item>
          <el-form-item label="① 产品在线率:" prop="p4.q1.grade">
            <el-radio-group v-model="subData.p4.q1.grade ">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p4.q1.grade !== '' && subData.p4.q1.grade < 3">
            <el-form-item prop="p4.q1.remark">
              <el-input type="textarea" v-model="subData.p4.q1.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="② 自身采集及抄表采集成功率和准确性:" prop="p4.q2.grade">
            <el-radio-group v-model="subData.p4.q2.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p4.q2.grade !== '' && subData.p4.q2.grade < 3">
            <el-form-item prop="p4.q2.remark">
              <el-input type="textarea" v-model="subData.p4.q2.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="③ 调试界面的简单或可操作性:" prop="p4.q3.grade">
            <el-radio-group v-model="subData.p4.q3.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p4.q3.grade !== '' && subData.p4.q3.grade < 3">
            <el-form-item prop="p4.q3.remark">
              <el-input type="textarea" v-model="subData.p4.q3.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="④ 产品功能的可扩展性:" prop="p4.q4.grade">
            <el-radio-group v-model="subData.p4.q4.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p4.q4.grade !== '' && subData.p4.q4.grade < 3">
            <el-form-item prop="p4.q4.remark">
              <el-input type="textarea" v-model="subData.p4.q4.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑤ 其余功能/性能:" prop="p4.other">
            <el-radio-group v-model="subData.p4.other">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">其它</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p4.other === 1">
            <el-form-item label="" prop="p4.otherCont">
              <el-input v-model="subData.p4.otherCont" placeholder="请填写"></el-input>
            </el-form-item>
            <el-form-item label="" prop="p4.otherGrade">
              <el-radio-group v-model="subData.p4.otherGrade">
                <el-radio :label="5">非常满意</el-radio>
                <el-radio :label="4">满意</el-radio>
                <el-radio :label="3">基本满意</el-radio>
                <el-radio :label="2">不满意</el-radio>
                <el-radio :label="1">非常不满意</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="subData.p4.otherGrade !== '' && subData.p4.otherGrade < 3">
            <el-form-item prop="p4.otherRemark">
              <el-input type="textarea" v-model="subData.p4.otherRemark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
        </template>
        <template v-if="subData.type.indexOf(5)+1">
          <el-form-item label="环网柜产品:" prop="p5.num">
          </el-form-item>
          <el-form-item label="① 远方/就地操作可靠性:" prop="p5.q1.grade">
            <el-radio-group v-model="subData.p5.q1.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p5.q1.grade !== '' && subData.p5.q1.grade < 3">
            <el-form-item prop="p5.q1.remark">
              <el-input type="textarea" v-model="subData.p5.q1.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="② 动作可靠性:" prop="p5.q2.grade">
            <el-radio-group v-model="subData.p5.q2.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p5.q2.grade !== '' && subData.p5.q2.grade < 3">
            <el-form-item prop="p5.q2.remark">
              <el-input type="textarea" v-model="subData.p5.q2.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="③ 面板开关状态指示正确性:" prop="p5.q3.grade">
            <el-radio-group v-model="subData.p5.q3.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p5.q3.grade !== '' && subData.p5.q3.grade < 3">
            <el-form-item prop="p5.q3.remark">
              <el-input type="textarea" v-model="subData.p5.q3.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="④ 调试界面的简单或可操作性:" prop="p5.q4.grade">
            <el-radio-group v-model="subData.p5.q4.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p5.q4.grade !== '' && subData.p5.q4.grade < 3">
            <el-form-item prop="p5.q4.remark">
              <el-input type="textarea" v-model="subData.p5.q4.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑤ 其余功能/性能:" prop="p5.other">
            <el-radio-group v-model="subData.p5.other">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">其它</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p5.other === 1">
            <el-form-item label="" prop="p5.otherCont">
              <el-input v-model="subData.p5.otherCont" placeholder="请填写"></el-input>
            </el-form-item>
            <el-form-item label="" prop="p5.otherGrade">
              <el-radio-group v-model="subData.p5.otherGrade">
                <el-radio :label="5">非常满意</el-radio>
                <el-radio :label="4">满意</el-radio>
                <el-radio :label="3">基本满意</el-radio>
                <el-radio :label="2">不满意</el-radio>
                <el-radio :label="1">非常不满意</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="subData.p5.otherGrade !== '' && subData.p5.otherGrade < 3">
            <el-form-item prop="p5.otherRemark">
              <el-input type="textarea" v-model="subData.p5.otherRemark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
        </template>
        <template v-if="subData.type.indexOf(6)+1">
          <el-form-item label="断路器产品:" prop="p6.num">
          </el-form-item>
          <el-form-item label="① 远方/就地操作可靠性:" prop="p6.q1.grade">
            <el-radio-group v-model="subData.p6.q1.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p6.q1.grade !== '' && subData.p6.q1.grade < 3">
            <el-form-item prop="p6.q1.remark">
              <el-input type="textarea" v-model="subData.p6.q1.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="② 动作可靠性:" prop="p6.q2.grade">
            <el-radio-group v-model="subData.p6.q2.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p6.q2.grade !== '' && subData.p6.q2.grade < 3">
            <el-form-item prop="p6.q2.remark">
              <el-input type="textarea" v-model="subData.p6.q2.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="③ 使用寿命:" prop="p6.q3.grade">
            <el-radio-group v-model="subData.p6.q3.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p6.q3.grade !== '' && subData.p6.q3.grade < 3">
            <el-form-item prop="p6.q3.remark">
              <el-input type="textarea" v-model="subData.p6.q3.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="④ 安装调试、维护便捷性:" prop="p6.q4.grade">
            <el-radio-group v-model="subData.p6.q4.grade">
              <el-radio :label="5">非常满意</el-radio>
              <el-radio :label="4">满意</el-radio>
              <el-radio :label="3">基本满意</el-radio>
              <el-radio :label="2">不满意</el-radio>
              <el-radio :label="1">非常不满意</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p6.q4.grade !== '' && subData.p6.q4.grade < 3">
            <el-form-item prop="p6.q4.remark">
              <el-input type="textarea" v-model="subData.p6.q4.remark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="⑤ 其余功能/性能:" prop="p6.other">
            <el-radio-group v-model="subData.p6.other">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">其它</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="subData.p6.other === 1">
            <el-form-item label="" prop="p6.otherCont">
              <el-input v-model="subData.p6.otherCont" placeholder="请填写"></el-input>
            </el-form-item>
            <el-form-item label="" prop="p6.otherGrade">
              <el-radio-group v-model="subData.p6.otherGrade">
                <el-radio :label="5">非常满意</el-radio>
                <el-radio :label="4">满意</el-radio>
                <el-radio :label="3">基本满意</el-radio>
                <el-radio :label="2">不满意</el-radio>
                <el-radio :label="1">非常不满意</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="subData.p6.otherGrade !== '' && subData.p6.otherGrade < 3">
            <el-form-item prop="p6.otherRemark">
              <el-input type="textarea" v-model="subData.p6.otherRemark" :rows="4"
                placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
            </el-form-item>
          </template>
        </template>
        <el-form-item label="3、您对产品交付及时性是否满意？" prop="q3.grade">
          <el-radio-group v-model="subData.q3.grade">
            <el-radio :label="5">非常满意</el-radio>
            <el-radio :label="4">满意</el-radio>
            <el-radio :label="3">基本满意</el-radio>
            <el-radio :label="2">不满意</el-radio>
            <el-radio :label="1">非常不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="subData.q3.grade !== '' && subData.q3.grade < 3">
          <el-form-item prop="q3.remark">
            <el-input type="textarea" v-model="subData.q3.remark" :rows="4"
              placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="4、市场人员服务态度是否良好？销售服务是否及时回应？" prop="q4.grade">
          <el-radio-group v-model="subData.q4.grade">
            <el-radio :label="5">非常满意</el-radio>
            <el-radio :label="4">满意</el-radio>
            <el-radio :label="3">基本满意</el-radio>
            <el-radio :label="2">不满意</el-radio>
            <el-radio :label="1">非常不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="subData.q4.grade !== '' && subData.q4.grade < 3">
          <el-form-item prop="q4.remark">
            <el-input type="textarea" v-model="subData.q4.remark" :rows="4"
              placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="5、售后人员服务态度是否良好？售后服务是否回应？" prop="q5.grade">
          <el-radio-group v-model="subData.q5.grade">
            <el-radio :label="5">非常满意</el-radio>
            <el-radio :label="4">满意</el-radio>
            <el-radio :label="3">基本满意</el-radio>
            <el-radio :label="2">不满意</el-radio>
            <el-radio :label="1">非常不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="subData.q5.grade !== '' && subData.q5.grade < 3">
          <el-form-item prop="q5.remark">
            <el-input type="textarea" v-model="subData.q5.remark" :rows="4"
              placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="6、售后人员专业性以及问题是否有效处理？" prop="q6.grade">
          <el-radio-group v-model="subData.q6.grade">
            <el-radio :label="5">非常满意</el-radio>
            <el-radio :label="4">满意</el-radio>
            <el-radio :label="3">基本满意</el-radio>
            <el-radio :label="2">不满意</el-radio>
            <el-radio :label="1">非常不满意</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="subData.q6.grade !== '' && subData.q6.grade < 3">
          <el-form-item prop="q6.remark">
            <el-input type="textarea" v-model="subData.q6.remark" :rows="4"
              placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="7、与同行业产品对比，您觉得我司产品性能、可靠性、交付、服务处于什么水平？" prop="q7.grade">
          <el-radio-group v-model="subData.q7.grade">
            <el-radio :label="5">非常好</el-radio>
            <el-radio :label="4">好</el-radio>
            <el-radio :label="3">一般</el-radio>
            <el-radio :label="2">较低</el-radio>
            <el-radio :label="1">偏低</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="subData.q7.grade !== '' && subData.q7.grade < 3">
          <el-form-item prop="q7.remark">
            <el-input type="textarea" v-model="subData.q7.remark" :rows="4"
              placeholder="很抱歉给您带来不好的体验，能举例说明不满意事项吗？我们将根据您的反馈，持续改进。"></el-input>
          </el-form-item>
        </template>
        <el-form-item label="8、您认为我司产品和服务有哪些需要改进的地方" prop="q8">
          <el-input type="textarea" v-model="subData.q8" placeholder="请留下您宝贵的意见" :rows="4"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('subData')" class="sub-btn">提&nbsp;&nbsp;交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import districts from '@/assets/map/districts'

  export default {
    data() {
      return {
        options: [],
        selectedOptions: [],
        cityArr: [], //城市列表
        areaArr: [], //区县列表
        province: "", //省
        city: "", //市
        area: "", // 区县,
        provinceCityArea: "", //选择器选择的省市区
        showMore: false,
        titles: [{
            title: '产品外观设计是否满意？包装防护是否有效？',
            type: 'radio'
          },
          {
            title: '产品功能、性能是否满足您的使用需求？',
            type: 'list'
          },
          {
            title: '您对产品交付及时性是否满意？',
            type: 'radio'
          },
          {
            title: '市场人员服务态度是否良好？销售服务是否及时回应？',
            type: 'radio'
          },
          {
            title: '售后人员服务态度是否良好？售后服务是否回应？',
            type: 'radio'
          },
          {
            title: '售后人员专业性以及问题是否有效处理？',
            type: 'radio'
          },
          {
            title: '与同行业产品对比，您觉得我司产品性能、可靠性、交付、服务处于什么水平？',
            type: 'radio'
          },
          {
            title: '您认为我司产品和服务有哪些需要改进的地方？欢迎留下宝贵意见。',
            type: 'textarea'
          }
        ],
        pQArr: [
          [{
              title: '设备在线稳定性：',
              type: 'radio'
            },
            {
              title: '遥信、遥测上报准确性，遥控动作准确性？',
              type: 'radio'
            },
            {
              title: '保护功能的准确性：',
              type: 'radio'
            },
            {
              title: '调试软件和就地维护功能的便捷性：',
              type: 'radio'
            },
            {
              title: '产品功能的可扩展：',
              type: 'radio'
            },
            {
              title: '其余功能/性能：',
              type: 'radio'
            }
          ],
          [{
              title: '设备在线稳定性：',
              type: 'radio'
            },
            {
              title: '遥信、遥测上报准确性，遥控动作准确性？',
              type: 'radio'
            },
            {
              title: '保护功能的准确性：',
              type: 'radio'
            },
            {
              title: '短路隔离或指示功能准确性：',
              type: 'radio'
            },
            {
              title: '调试软件和就地维护功能的便捷性：',
              type: 'radio'
            },
            {
              title: '其余功能/性能：',
              type: 'radio'
            }
          ],
          [{
              title: '设备在线稳定性：',
              type: 'radio'
            },
            {
              title: '短路故障准确性：',
              type: 'radio'
            },
            {
              title: '接地故障准确性：',
              type: 'radio'
            },
            {
              title: '安装、维护便捷性：',
              type: 'radio'
            },
            {
              title: '其余功能/性能：',
              type: 'radio'
            }
          ],
          [{
              title: '产品在线率：',
              type: 'radio'
            },
            {
              title: '自身采集及抄表采集成功率和准确性：',
              type: 'radio'
            },
            {
              title: '调试界面的简单或可操作性：',
              type: 'radio'
            },
            {
              title: '产品功能的可扩展性：',
              type: 'radio'
            },
            {
              title: '其余功能/性能：',
              type: 'radio'
            }
          ],
          [{
              title: '远方/就地操作可靠性：',
              type: 'radio'
            },
            {
              title: '动作可靠性：',
              type: 'radio'
            },
            {
              title: '面板开关状态指示正确性：',
              type: 'radio'
            },
            {
              title: '安装调试、维护便捷性：',
              type: 'radio'
            },
            {
              title: '其余功能/性能：',
              type: 'radio'
            }
          ],
          [{
              title: '远方/就地操作可靠性：',
              type: 'radio'
            },
            {
              title: '动作可靠性：',
              type: 'radio'
            },
            {
              title: '使用寿命：',
              type: 'radio'
            },
            {
              title: '安装调试、维护便捷性：',
              type: 'radio'
            },
            {
              title: '其余功能/性能：',
              type: 'radio'
            }
          ],
        ],
        products: ['DTU', 'FTU', '故障指示器', '用电集采', '环网柜', '断路器'],
        subObj: {},
        subData: {
          company: '',
          provinceCityArea: '',
          name: '',
          tel: '',
          type: [],
          q1: {
            grade: '',
            remark: ''
          },
          average: '',
          p1: {
            num: '',
            time: '',
            q1: {
              grade: '',
              remark: ''
            },
            q2: {
              grade: '',
              remark: ''
            },
            q3: {
              grade: '',
              remark: ''
            },
            q4: {
              grade: '',
              remark: ''
            },
            q5: {
              grade: '',
              remark: ''
            },
            q6: null,
            other: '',
            otherGrade: '',
            otherCont: '',
            otherRemark: ''
          },
          p2: {
            num: '',
            time: '',
            q1: {
              grade: '',
              remark: ''
            },
            q2: {
              grade: '',
              remark: ''
            },
            q3: {
              grade: '',
              remark: ''
            },
            q4: {
              grade: '',
              remark: ''
            },
            q5: {
              grade: '',
              remark: ''
            },
            q6: null,
            other: '',
            otherGrade: '',
            otherCont: '',
            otherRemark: ''
          },
          p3: {
            num: '',
            time: '',
            q1: {
              grade: '',
              remark: ''
            },
            q2: {
              grade: '',
              remark: ''
            },
            q3: {
              grade: '',
              remark: ''
            },
            q4: {
              grade: '',
              remark: ''
            },
            q5: null,
            other: '',
            otherGrade: '',
            otherCont: '',
            otherRemark: ''
          },
          p4: {
            num: '',
            time: '',
            q1: {
              grade: '',
              remark: ''
            },
            q2: {
              grade: '',
              remark: ''
            },
            q3: {
              grade: '',
              remark: ''
            },
            q4: {
              grade: '',
              remark: ''
            },
            q5: null,
            other: '',
            otherGrade: '',
            otherCont: '',
            otherRemark: ''
          },
          p5: {
            num: '',
            time: '',
            q1: {
              grade: '',
              remark: ''
            },
            q2: {
              grade: '',
              remark: ''
            },
            q3: {
              grade: '',
              remark: ''
            },
            q4: {
              grade: '',
              remark: ''
            },
            q5: null,
            other: '',
            otherGrade: '',
            otherCont: '',
            otherRemark: ''
          },
          p6: {
            num: '',
            time: '',
            q1: {
              grade: '',
              remark: ''
            },
            q2: {
              grade: '',
              remark: ''
            },
            q3: {
              grade: '',
              remark: ''
            },
            q4: {
              grade: '',
              remark: ''
            },
            q5: null,
            other: '',
            otherGrade: '',
            otherCont: '',
            otherRemark: ''
          },
          q3: {
            grade: '',
            remark: ''
          },
          q4: {
            grade: '',
            remark: ''
          },
          q5: {
            grade: '',
            remark: ''
          },
          q6: {
            grade: '',
            remark: ''
          },
          q7: {
            grade: '',
            remark: ''
          },
          q8: ''
        },
        rules: {
          company: [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          provinceCityArea: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          type: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'q1.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'q1.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p1.q1.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p1.q1.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p1.q2.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p1.q2.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p1.q3.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p1.q3.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p1.q4.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p1.q4.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p1.q5.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p1.q5.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p1.other': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p1.otherCont': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p1.otherGrade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p1.otherRemark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p2.q1.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p2.q1.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p2.q2.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p2.q2.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p2.q3.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p2.q3.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p2.q4.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p2.q4.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p2.q5.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p2.q5.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p2.other': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p2.otherCont': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p2.otherGrade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p2.otherRemark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p3.q1.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p3.q1.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p3.q2.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p3.q2.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p3.q3.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p3.q3.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p3.q4.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p3.q4.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p3.other': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p3.otherCont': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p3.otherGrade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p3.otherRemark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p4.q1.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p4.q1.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p4.q2.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p4.q2.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p4.q3.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p4.q3.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p4.q4.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p4.q4.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p4.other': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p4.otherCont': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p4.otherGrade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p4.otherRemark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p5.q1.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p5.q1.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p5.q2.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p5.q2.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p5.q3.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p5.q3.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p5.q4.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p5.q4.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p5.other': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p5.otherCont': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p5.otherGrade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p5.otherRemark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p6.q1.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p6.q1.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p6.q2.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p6.q2.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p6.q3.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p6.q3.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p6.q4.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p6.q4.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p6.other': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p6.otherCont': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'p6.otherGrade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'p6.otherRemark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'q3.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'q3.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'q4.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'q4.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'q5.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'q5.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'q6.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'q6.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          'q7.grade': [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          'q7.remark': [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          q8: [{
            required: true,
            message: '请填写',
            trigger: ['blur', 'change']
          }],
          // tel: [{
          //   required: true,
          //   pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          //   message: "请输入正确的手机号码",
          //   trigger: "blur"
          // }],

        }
      }
    },
    mounted() {
      this.initDistPicker()
    },
    methods: {
      initDistPicker() {
        let self = this;
        let distData = districts
        let options = [];
        // 省
        for (var provinceKy in distData["100000"]) {
          let optProvinceItem = {
            value: provinceKy,
            label: distData["100000"][provinceKy]
          };
          if (distData[provinceKy]) {
            // 市
            for (var cityKy in distData[provinceKy]) {
              optProvinceItem.children = optProvinceItem.children ?
                optProvinceItem.children : [];
              let optCityItem = {
                value: cityKy,
                label: distData[provinceKy][cityKy]
              };
              if (distData[cityKy]) {
                // 区
                for (var areaKy in distData[cityKy]) {
                  optCityItem.children = optCityItem.children ?
                    optCityItem.children : [];
                  let optAreaItem = {
                    value: areaKy,
                    label: distData[cityKy][areaKy]
                  };
                  optCityItem.children.push(optAreaItem);
                }
              }
              optProvinceItem.children.push(optCityItem);
            }
          }
          options.push(optProvinceItem);
        }
        self.distData = distData;
        self.options = options;
      },
      //选择地区
      handleChange(value) {
        let self = this;
        console.log("value=>", value);
        //获取省名
        self.options.map((item, index) => {
          if (item.value == value[0]) {
            self.cityArr = item.children; //存储城市列表
            self.province = item.label;
          }
        });
        //获取市名
        self.cityArr.map((item, index) => {
          if (item.value == value[1]) {
            self.areaArr = item.children; //存储区县列表
            self.city = item.label;
          }
        });
        //获取区县名
        self.areaArr.map((item, index) => {
          if (item.value == value[2]) {
            self.area = item.label;
          }
        });
        self.provinceCityArea = self.province + self.city + self.area;
      },
      getGrade() {
        let gradeArr = []
        gradeArr.push(this.subData.q1, this.subData.q3, this.subData.q4, this.subData.q5, this.subData.q6, this.subData
          .q7)
        this.subData.type.map(item => {
          let obj = this.subData['p' + item]
          for (var key in obj) {
            if (key.match(RegExp(/^q/))) {
              gradeArr.push(obj[key])
            }
          }
          if (this.subData['p' + item].other === 1) {
            gradeArr.push(obj.otherGrade)
          }
        })
        let sum = 0
        gradeArr.map(num => {
          return sum += num
        })
        this.average = (sum / gradeArr.length).toFixed(2)
      },
      getProduct() {
        this.subData.type.map((item, index) => {
          let obj = this.subData['p' + item]
          let pObj = {
            productName: this.products[item - 1],
            productNum: obj.num,
            productDate: obj.time,
            subset: []
          }
          let qArr = this.pQArr[item - 1]
          let timer = 0
          for (var key in obj) {
            if (key.match(RegExp(/^q/))) {
              if(timer === qArr.length - 1) {
                if(obj.other === 0) continue
                pObj.subset.push({
                  description: obj.otherCont,
                  manner: qArr[timer].type,
                  result: obj.otherGrade,
                  remark: obj.otherRemark
                })
              } else {
                pObj.subset.push({
                  description: qArr[timer].title,
                  manner: qArr[timer].type,
                  result: obj[key].grade,
                  remark: obj[key].grade < 3 ? obj[key].remark : '无',
                })
              }
              
              timer++
            }
          }
          // if (this.subData['p' + item].other === 1) {
          //   gradeArr.push(obj.otherGrade)
          // }
          this.subObj.appraisalDescInfoList[1].children.push(pObj)
        })
      },
      changeType(value) {
        let arr = []
        value.map(item => {
          switch (item) {
            case 1:
              arr.push('DTU')
              break;
            case 2:
              arr.push('FTU')
              break;
            case 3:
              arr.push('GZQ')
              break;
            case 4:
              arr.push('YDQ')
              break;
            case 5:
              arr.push('HWG')
              break;
            default:
              arr.push('DLQ')
              break;
          }
        })
        return arr
      },
      getSubObj() {
        this.subObj = {
          appraisalBasicInfo: {
            customerName: this.subData.company,
            area: this.provinceCityArea,
            customerFullName: this.subData.name,
            contactInformation: this.subData.tel,
            productCategory: this.changeType(this.subData.type),
          },
          appraisalDescInfoList: []
        }
        this.getFU()
        this.getProduct()
      },
      getFU() {
        [1, 2, 3, 4, 5, 6, 7, 8].map(item => {
          if (item === 2) {
            this.subObj.appraisalDescInfoList.push({
              id: item,
              // description: this.titles[item - 1].title,
              // type: this.titles[item - 1].type,
              children: []
            })
          } else if (item === 8) {
            this.subObj.appraisalDescInfoList.push({
              id: item,
              description: this.titles[item - 1].title,
              manner: this.titles[item - 1].type,
              remark: this.subData['q' + item]
            })
          } else {
            this.subObj.appraisalDescInfoList.push({
              id: item,
              description: this.titles[item - 1].title,
              manner: this.titles[item - 1].type,
              result: this.subData['q' + item].grade,
              remark: this.subData['q' + item].grade < 3 ? this.subData['q' + item].remark : '无',
            })
          }
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.getSubObj()
            this.$axios.post('/appraisal/saveAppraisalInfo', this.subObj).then(res => {
              this.$refs[formName].resetFields()
              // this.$refs.upload.clearFiles()
              this.$alert('提交成功，感谢您宝贵的意见及反馈！', '', {
                confirmButtonText: '确定',
                customClass: 'my-alert',
                center: true,
                callback: action => {}
              })
            })
          } else {
            console.log('error submit!!');
            return false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .cont-box {
    position: relative;
    /* height: 100%; */
  }

  .cont-box>img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
  }

  .cont-box>img.img01 {
    bottom: 0;
    top: auto;
  }

  .el-form {
    padding: 0 2rem;
  }

  .el-form-item>>>.el-form-item__label {
    line-height: 1.4;
    padding-bottom: .6em !important;
  }

  .el-form-item>>>.el-form-item__content {
    line-height: 30px;
  }

  .el-checkbox {
    line-height: 24px;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  .logo {
    width: 40%;
    padding: 2rem 0 .6rem;
  }

  .title {
    width: 60%;
  }

  .title-d {
    color: #323232;
    font-size: 26px;
    padding: 0 0 2rem;
  }

  .title-c {
    color: #646464;
    font-size: 14px;
    padding: 0 2rem 1rem;
  }

  .title-span {
    display: inline-block;
    padding-top: 4px;
    text-indent: 2em;
  }

  .el-form--label-top>>>.el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  .el-button {
    width: 100%;
  }

  .el-button.sub-btn {
    margin: 1rem 0 2rem;
    background-color: #e8320d;
    border: none;
    font-size: 1.2rem;
    font-weight: bold;
    padding: 1rem 0;
  }

  .el-button.pop-btn {
    width: 6rem;
    background-color: #e8320d;
    border: none;
    margin: 1rem 0 .5rem;
  }

  .pop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .6);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pop-cont {
    box-sizing: border-box;
    width: 72%;
    height: 16rem;
    background: white;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 1rem;
  }

  .pop-cont>p:nth-of-type(1) {
    font-size: 1.2rem;
    font-weight: bold;
    margin: .5rem 0 1rem;
  }

  .pop-cont>p:nth-of-type(2) {
    color: #e8320d;
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: .5rem;
  }

  .pop-cont>p:nth-of-type(3) {
    color: #646464;
    text-align: center;
    line-height: 2rem;
  }

  .der {
    padding: 0 2rem 2rem;
  }

  .der>p {
    line-height: 1.8rem;
    color: #e8320d;
  }

  .der>p>span:nth-of-type(1) {
    font-weight: bold;
  }

  .der>p:nth-of-type(2) {
    margin-top: .5rem;
    font-size: .8rem;
    color: #646464;
    line-height: 1.2rem;
  }

  .my-upload>>>.el-upload {
    width: 100%;
  }

  .el-input>>>.el-input__inner,
  .el-textarea>>>.el-textarea__inner {
    color: #323232;
  }

  .el-radio {
    padding: 5px 0;
  }

  .el-cascader {
    width: 100%;
    /* margin-bottom: 22px; */
  }
</style>
